export const GET_STORE_REQUEST = "GET_STORE_REQUEST";
export const GET_STORE_SUCCESS = "GET_STORE_SUCCESS";
export const GET_STORE_FAIL = "GET_STORE_FAIL";
export const STORE_RESET = "STORE_RESET";
export const STORE_UNAVAILABLE_ALERT_TRIGGER = "STORE_UNAVAILABLE_ALERT_TRIGGER";
